import Radio from '../Radio/Radio'
import classes from './LabeledRadioWithText.module.scss'
import {
  type ReactElement,
  type ReactNode
} from 'react'

export interface Props {
  children?: ReactElement
  group: string
  isChecked: boolean
  isDisabled?: boolean
  label: ReactNode
  onChange: (value: boolean) => void
  variant?: 'fixedWidth' | ''
}

const LabeledRadioWithText = ({
  children,
  group,
  isChecked = false,
  isDisabled = false,
  label,
  onChange,
  variant = 'fixedWidth'
}: Props) => {
  const handleChange = () => {
    onChange(!isChecked)
  }

  const getClasses = () => {
    const baseClass = classes.LabeledRadioWithText

    const isCheckedClass = isChecked
      ? classes.isChecked
      : ''

    const isDisabledClass = isDisabled
      ? classes.Disabled
      : ''

    const isCheckedIsDisabled = isChecked && isDisabled
      ? classes.isCheckedAndIsDisabled
      : ''

    const finalClasses = [
      baseClass,
      isCheckedClass,
      isDisabledClass,
      isCheckedIsDisabled
    ].filter(classname => classname)

    return finalClasses.join(' ')
  }

  const handleInputClick = () => {
    if (children && (children.props as any).isReadOnly) {
      handleChange()
    }
  }

  return (
    <label
      className={getClasses() + ' ' + classes[variant]}
      onClick={handleChange}
    >
      <span className={classes.buttonWrapper}>
        <Radio
          isChecked={isChecked}
          isDisabled={isDisabled}
          name={group}
          onChange={handleChange}
        />
        {
          children &&
            <span className={classes.labelWrapper}>
              {
                // only for Input and Paragraph usage for now, to refactor in future if have better approach
                <children.type
                  {...(children.props as any)}
                  onClick={() => handleInputClick()}
                />
              }
            </span>
        }
      </span>
      {label}
    </label>
  )
}

export default LabeledRadioWithText
